import React, { useState } from "react";
import clsx from "clsx";
import _ from "lodash";
import { makeStyles, MuiThemeProvider } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import CircularProgress from "@material-ui/core/CircularProgress";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import { connect } from "react-redux";
import moment from "moment";
import {
  getCustomEventLocations,
  getTemplateLocations,
  moveMarkers,
  setTemplateId,
} from "../../actions";
import { mainTheme } from "../../settings";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  list: {
    width: "100%",
  },
  fullList: {
    width: "auto",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
    textAlign: "left",
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  accordation: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  formControl: {
    margin: theme.spacing(1),
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  typography: {
    minWidth: "100%",
    wordBreak: "break-word",
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
}));

const EventList = (props) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(-1);

  if (!props.open) return <div />;

  const renderEventName = ({
    eventName,
    nameOfEvent,
    updatedOn,
    locationName,
    intro_en,
  }) => {
    if (!_.isString(intro_en)) {
      return (
        <div>
          <Typography component="div" className={classes.heading}>
            {nameOfEvent || eventName || locationName}
          </Typography>
          <Typography component="div" className={classes.secondaryHeading}>
            This event is incomplete
          </Typography>
        </div>
      );
    }

    if (updatedOn) {
      return (
        <div style={{ flex: 1, justifyContent: "flex-start" }}>
          <Typography component="div" className={classes.heading}>
            {nameOfEvent || eventName || locationName}
          </Typography>
          <Typography component="div" className={classes.secondaryHeading}>
            Updated on {moment(updatedOn.toDate()).format("MMM Do YY, H:mm")}
          </Typography>
        </div>
      );
    }

    return (
      <Typography component="div" className={classes.heading}>
        {nameOfEvent || eventName}
      </Typography>
    );
  };

  const renderUserEventButtons = (template) => {
    if (Object.keys(props.template).length > 0 && !props.template.id) {
      return (
        <Button
          onClick={() => {
            props.setTemplateId(template.id);
          }}
          variant="contained"
          color="primary"
        >
          Link
        </Button>
      );
    }

    if (_.isString(_.get(template, "intro_en"))) {
      return (
        <Button
          onClick={() => {
            props.getCustomEventLocations(template.id);
            setExpanded(-1);
            props.close();
          }}
          variant="contained"
          color="primary"
        >
          Select
        </Button>
      );
    } 

    return <></>
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === "top" || anchor === "bottom",
      })}
      role="presentation"
    >
      {props.loading ? (
        <CircularProgress />
      ) : (
        <div>
          <div style={{ textAlign: "center", fontSize: 20 }}>Templates</div>
          <List>
            {props.eventTemplates.map((template, i) => (
              <Accordion
                key={template.id || i}
                expanded={expanded === i}
                onChange={handleChange(i)}
              >
                <AccordionSummary
                  className="main-color"
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography component="div" className="capitalize">
                    {template["key"].replaceAll("_", " ")}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  component="div"
                  className={classes.accordation}
                >
                  <Typography component="div" className={classes.typography}>
                    <MuiThemeProvider theme={mainTheme}>
                      <Button
                        className={classes.typography}
                        onClick={() => {
                          props.getTemplateLocations(template["key"]);
                          setExpanded(-1);
                        }}
                        variant="contained"
                        color="primary"
                      >
                        Select
                      </Button>
                    </MuiThemeProvider>
                  </Typography>
                  <Typography
                    component="div"
                    style={{ whiteSpace: "pre-line" }}
                  >
                    {
                      template["intro_en"]
                        .replaceAll("{{city}}", "your city")
                        .split(".")[0]
                    }
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </List>
          <Divider />
          <div style={{ textAlign: "center", fontSize: 20 }}>My Events</div>
          <List>
            {props.userEvents.map((template, i) => (
              <Accordion
                key={template.id || i}
                expanded={expanded === template.id}
                onChange={handleChange(template.id)}
                style={{
                  backgroundColor:
                    _.get(props.template, "id") === template.id
                      ? "#648E64"
                      : "",
                }}
              >
                <AccordionSummary
                  className="main-color"
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography component="div" className="capitalize">
                    {renderEventName(template)}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  component="div"
                  className={classes.accordation}
                >
                  <Typography component="div" className={classes.typography}>
                    {renderUserEventButtons(template)}
                  </Typography>
                  <Typography
                    component="div"
                    style={{ whiteSpace: "pre-line" }}
                  >
                    {(template["intro_en"] || "").split(".")[0]}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </List>
        </div>
      )}
    </div>
  );

  return (
    <>
      <Divider />
      {list(props.anchor)}
    </>
  );
};

const mapStateToProps = ({ events }) => {
  const {
    loading,
    gameIds,
    eventTemplates,
    userEvents,
    template,
    center,
    locations,
  } = events;

  return {
    loading,
    gameIds,
    eventTemplates,
    userEvents: userEvents.sort((a, b) => b.startTime - a.startTime),
    template,
    center,
    locations,
  };
};

export default connect(mapStateToProps, {
  getCustomEventLocations,
  moveMarkers,
  getTemplateLocations,
  setTemplateId,
})(EventList);
